import React from "react";

export default function ActivateIcon() {
  return (
    <React.Fragment>
      <svg
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M31 8L47.2635 14.7365L54 31L47.2635 47.2635L31 54L14.7365 47.2635L8 31L14.7365 14.7365L31 8Z"
          fill="#84F5BA"
        />
        <path
          d="M28.5 5L45.117 11.883L52 28.5L45.117 45.117L28.5 52L11.883 45.117L5 28.5L11.883 11.883L28.5 5Z"
          fill="white"
          stroke="#222222"
          strokeWidth="2"
        />
        <path
          d="M38.1304 27.5714C37.4436 22.7253 33.3144 19 28.323 19C24.2329 19 20.7217 21.5015 19.2092 25.0714M38.1304 27.5714L40 25.0714M38.1304 27.5714L35.4 26.1429M18.5157 30.4286C19.2025 35.2747 23.3317 39 28.323 39C32.3858 39 35.8775 36.5318 37.4063 33M18.5157 30.4286L17 33.6429M18.5157 30.4286L21.6 31.8571"
          stroke="#222222"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </React.Fragment>
  );
}
